export var emptyString = '';
export var unassignedPermit = 'Unassigned';
export var apiTruckType = 'Truck';
export var uiTruckType = 'Truck/Pick-up';
export var msEmployee = 'MS Employee';
export var msFteOrVendorEmployee = 'MS FTE or Vendor Employee';
export var environment = {
    PPE: 'ppe',
    PROD: 'prod',
    RING_0: 'ring0',
    RING_1: 'ring1',
    RING_2: 'ring2',
    RING_3: 'ring3',
    RING_4: 'ring4',
};
